export const FETCH_TOP_PANELS_REQUEST = "FETCH_TOP_PANELS_REQUEST";
export const FETCH_TOP_PANELS_SUCCESS = "FETCH_TOP_PANELS_SUCCESS";
export const FETCH_TOP_PANELS_FAILURE = "FETCH_TOP_PANELS_FAILURE";
